import MobileDetect from 'mobile-detect';
import * as Actions from '../Actions/FilterActions';

const md = new MobileDetect(window.navigator.userAgent);

const initialState = {
    data: null,
    button: false, // (_.isNull(md.mobile()) || _.isNull(md.tablet())),
};

const FilterReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_FILTER:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.SAVE_FILTER:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.ERROR_FILTER:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.TOGGLE_PAINEL:
            {
                return {
                    ...state,
                    button: !state.button
                };
            }
        default:
            {
                return state;
            }
    }
};

export default FilterReducer;
